<nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top header-height">
    <div class="container-fluid right-align">
        <a class="navbar-brand logo-icon" href="#">
            <img src="assets/images/Logos.svg" height="30" alt="acc Logo" loading="lazy">
        </a>
        <div class="col-md-12 col-lg-12 col-sm-12 d-flex align-items-center justify-content-center header-font">
            MeteredGPT
        </div>
    </div>
</nav>
